import {
  colorByAlertLevel,
  coolGrey,
  FindingResult,
  getFindingLevel,
} from '@jupiterone/jupiter-web-toolkit';
import { GraphVertex } from '../types';
const ALERT_LEVEL_CLASSES = ['Finding', 'Vulnerability', 'Problem', 'Alert'];
const containsAny = (arr1: string[], arr2: string[]) => {
  const result = arr1.filter((i) => arr2.indexOf(i) >= 0);
  if (result.length > 0) {
    return result[0];
  }
  return undefined;
};

const getStrokeColor = (vertex: GraphVertex): string | null => {
  const vertexClasses = vertex?.entity?._class || [];
  const result = containsAny(ALERT_LEVEL_CLASSES, vertexClasses);
  if (result) {
    const level = getFindingLevel(vertex as FindingResult);
    return colorByAlertLevel(level);
  }
  if (vertex.entity?._deleted) {
    return coolGrey[300];
  }
  return null;
};

export default getStrokeColor;
